import { LoadingState } from '@vrzl/ui';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from './authProvider';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState className="min-h-screen" />;
  }

  if (!isAuthenticated) {
    // Inclusief search: bij een documentlink staat de te tonen pagina en de
    // zoekterm in de querystring, en zonder die parameters opent het document
    // wel maar op de verkeerde plek.
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <>{children}</>;
}
